import FormHistogram from './FormHistogram';

export default FormHistogram;
